import { dbsKeys } from "data/dbsKeys";
import { readCollection, writeCollection } from "data/dbsStorage";

const EMPTY = null;

export const sessionRepo = {
  getSession() {
    return readCollection(dbsKeys.session, EMPTY);
  },

  signIn({ email, password, displayName, role }) {
    const session = {
      userId: "u-" + Date.now().toString(36),
      email: email || null,
      displayName: displayName || "Kullanıcı",
      role: role || "customer",
    };
    writeCollection(dbsKeys.session, session);
    return session;
  },

  register({ email, password, displayName, role }) {
    return sessionRepo.signIn({ email, password, displayName, role });
  },

  signInAsGuest() {
    return sessionRepo.signIn({ displayName: "Misafir", role: "customer" });
  },

  signOut() {
    writeCollection(dbsKeys.session, null);
  },
};
